import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EulaService {
  private baseUrl = environment.baseUrl;
  private asgSecurityUrl = environment.asgSecurityUrl;

  constructor(private http: HttpClient) { }

  acceptEula(payload) {
    return this.http.put(`${this.asgSecurityUrl}/v1/users/acceptEula`, payload);
  }

  downloadEulaContent() {
    return this.http.get(`${this.baseUrl}/Iforms-webforms-app/v1/eula/content/download`, { responseType: 'text' });
  }

}
